export const EMPTY_VALUE_LABEL = 'empty';
export const EMPTY_ARRAY_MARKER = '[]';
export const EMPTY_OBJECT_MARKER = '{}';
export const INDENT_PER_DEPTH = 24;
export const BASE_PADDING_OFFSET = 8;
export const BLANK_STRING_LABEL = '(blank)';
